import { render, staticRenderFns } from "./FormControlMProductsProductsTypeFeatures.vue?vue&type=template&id=5f855b0b&scoped=true"
import script from "./FormControlMProductsProductsTypeFeatures.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMProductsProductsTypeFeatures.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlMProductsProductsTypeFeatures.vue?vue&type=style&index=0&id=5f855b0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f855b0b",
  null
  
)

export default component.exports